import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createStore} from "redux";
import reducer from "./reducer";
import {Provider} from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';


const store = createStore(reducer, {
  farmList: {
    farmList: [],
    farmActuators: [],
    selectedFarm: {},
    farmSource: {},
    farmMqttStatus: null,
    selectedFarmScout:[]
  },
  department: {
    selectedDepartment: {}
  },

  machine: {
    selectedMachine: {}
  },

  setting: {
    toggle: 0,
    isChangePasswordVisible: false,
    isLoading: false,
    isLoadingCount: 0,
    confirmationDialog: {},
    timePicker: {}
  },
  plotList: {
    plotList: [],
    selectedPlot: {},
    plotIrrigationStatus: {},
    bottomReached: false,
    plotMqtt: {},
  },

  sensor: {
    clusters: [],
    selectedSensor: {},
    findLocation: false,
    selectedCoordinate: {},
  },
  reportList: {
    // selectedReportType: "DAILY",
    selectedReport: "",
    selectedGraphType: "ANNUAL",
    selectedReportType: "DAILY",
    selectedShiftType: "SHIFT_A",
    selectedShiftTypeGraph: "SHIFT_A",
  },
  modules: {
    enabledModules: {},
    farmModules: {},
  }
});

// ReactDOM.render(
//   <React.StrictMode store={store}>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

ReactDOM.render(
  <Provider store={store}>
    <App/>
  </Provider>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
